interface HeroSectionProps {
  /** Whether to show the subheadline (hidden when features are above fold) */
  showSubhead?: boolean;
  /** Whether this is a multi-disease cohort (changes headline) */
  isMultiDiseaseCohort?: boolean;
}

export function HeroSection({ showSubhead = true, isMultiDiseaseCohort = false }: HeroSectionProps) {
  return (
    <div className="flex flex-col gap-1 pt-3 lg:pt-0">
      <h1 className="text-[30px] font-bold leading-[1.3] text-catch-dark-blue-90 lg:text-5xl">
        {isMultiDiseaseCohort
          ? 'Stay ahead of the four health risks that matter most'
          : 'Stay ahead of cancer'}
      </h1>

      {showSubhead && (
        <p className="text-sm leading-relaxed text-slate-500 lg:text-lg">
          No more guessing, no more spiraling. Just a clear, science-backed plan
          that puts your health in your hands.
        </p>
      )}
    </div>
  );
}

export default HeroSection;
